import React, { useEffect, useState } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleLogin from "react-google-login";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import t from "../../i18n/i18n";
import useApi from "../../services/api";
import { handleApiErrors } from "../../utils/handleErrors";
import DefRoutes from "../../routes/routes.json";
import { SignIn as SignInStore } from "../../store/reducers/auth.reducer";
import Notify from "../../components/notification/notify";

function Login({ setComponente, componente }) {
  /*useInitPage({
    title: t("MainLogin.Title"),
  });*/

  const { ApiSignIn, ApiSignInWithProvider } = useApi();

  const { push } = useHistory();

  const dispatch = useDispatch();
  const [form, setForm] = useState({ tfaAuthorization: !!localStorage.getItem("@TFA/Authorization") });

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function SignInSubmit(e) {
    e.preventDefault();
    if (!form.login) return Notify({ type: "danger", message: t("Errors.EmptyLogin") });
    if (!form.password) return Notify({ type: "danger", message: t("Errors.EmptyPassword") });
    const { data } = await ApiSignIn(form);
    if (data.errors) {
      return handleApiErrors(data.errors);
    }
    if (data.tfa) {
      ///*return*/ push(DefRoutes.TFA, data);
      //window.open(DefRoutes.TFA, "_parent");
    }
    dispatch(SignInStore(data));
    ///*return*/ push(DefRoutes.Home);
    //window.open(DefRoutes.Home, "_parent");
    setComponente(!componente);
  }

  async function SubmitFacebook({ userID }) {
    if (!userID) return;
    const params = {
      provider_id: userID,
      tfaAuthorization: !!localStorage.getItem("@TFA/Authorization"),
    };
    const { data } = await ApiSignInWithProvider(params);
    if (data.errors) {
      return handleApiErrors(data.errors);
    }
    if (data.tfa) {
      ///*return*/ push(DefRoutes.TFA, data);
      //window.open(DefRoutes.TFA, "_parent");
    }
    dispatch(SignInStore(data));
    ///*return*/ push(DefRoutes.Home);
    //window.open(DefRoutes.Home, "_parent");
    setComponente(!componente);
  }

  async function SubmitGoogle({ googleId }) {
    if (!googleId) return;
    const params = {
      provider_id: googleId,
    };
    const { data } = await ApiSignInWithProvider(params);
    console.log(data);
    if (data.errors) {
      return handleApiErrors(data.errors);
    }
    if (data.tfa) {
      ///*return*/ push(DefRoutes.TFA, data);
      //window.open(DefRoutes.TFA, "_parent");
    }
    dispatch(SignInStore(data));
    ///*return*/ push(DefRoutes.Home);
    //window.open(DefRoutes.Home, "_parent");
    setComponente(!componente);
  }

  return (
    <div className="login-main-panel">
      <div className="login-main-box">
        <div className="login-panel-header">
          <div className="header-title-icon">
            <i className="user-icon">
              <img src="../images/user-icon-white.png" alt="" />
            </i>
            <h3>{t("MainLogin.LoginTitle")}</h3>
          </div>
          <div className="regester-link">
            <a href="#@">{t("MainLogin.Register")}</a>
          </div>
        </div>
        <div className="login-inside-warp">
          <div className="user-form-box">
            <form onSubmit={SignInSubmit}>
              <div className="input-box">
                <input
                  type="text"
                  name="login"
                  value={form.login}
                  onChange={handleInputChange}
                  placeholder={t("MainLogin.InputEmail")}
                />
              </div>
              <div className="input-box">
                <input
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleInputChange}
                  placeholder={t("MainLogin.InputPass")}
                />
              </div>
              <div className="form-captcha">
                <img src="../images/g-captcha.png" alt="" />
              </div>
              <div className="image-btn-group">
                <button type="button" className="img-btn btn-exquechi" onClick={() => push(DefRoutes.RecoveryPassword)}>
                  {t("MainLogin.Forgot")}
                </button>
                <button type="submit" className="img-btn btn-confirmar">
                  {t("MainLogin.Login")}
                </button>
              </div>

              <div className="social-login">
                <p>{t("MainLogin.OtherLogin")}</p>
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                  fields="name,email,picture"
                  callback={SubmitFacebook}
                  render={(renderProps) => (
                    <button type="button" onClick={renderProps.onClick}>
                      <img src="../images/facebook-m.png" alt="" />
                    </button>
                  )}
                />
                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_APP_ID}
                  render={(renderProps) => {
                    return (
                      <button type="button" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                        <img src="../images/google-m.png" alt="" />
                      </button>
                    );
                  }}
                  buttonText="Login"
                  onSuccess={SubmitGoogle}
                  onFailure={(e) => console.log(e)}
                  cookiePolicy={"single_host_origin"}
                />
              </div>
            </form>
          </div>

          <span className="media-shap">
            <img src="../images/imagem_personagem.png" alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default Login;
